import React from 'react';

export const PageHeading = ({ title, isSimulator = false, purpose }) => {
  return (
    <div className={`loan-main-title-npp ${ isSimulator ? 'red-title-scp' : '' }`}>
      <h1>{ title }</h1>
      { !isSimulator ? <p><i className={purpose["icon"]}></i> {purpose["text"]}</p> : null }
    </div>
  );
}
